import DataReportRoot from '@/views/dataReport';
import jsDataMonitor from './jsDataMonitor';
import captchaMonitor from './captchaMonitor';
import {DATA_REPORT_ROOT} from '@/enmus/PageNames';
import apiServerMonitor from './apiServerMonitor';
export default {
    path: 'dataReport',
    name: 'dataReport',
    component: DataReportRoot,
    redirect: jsDataMonitor.path,
    meta: {
        name: DATA_REPORT_ROOT,
        title: '数据监控'
    },
    children: [
        apiServerMonitor,
        jsDataMonitor,
        captchaMonitor
    ]
};